import { createContext } from 'react';

/**
 * How tall `IntakeShell` should make itself.
 *
 * The shell has always sized itself to the viewport minus exactly 64px of app
 * chrome. That assumption breaks the moment anything else is stacked above it:
 * the shell overflows, the page grows a second scrollbar, and the sticky
 * Back/Continue footer slot is pushed past the bottom of the window.
 *
 * `IntakeHubSections` (GDN-3405) puts a section navigation above the form, so
 * it owns the viewport height itself and hands the shell a plain `100%` of the
 * slot it was given. The default below is the pre-shell value, so every surface
 * that renders `IntakeExperience` without a provider — the customer route with
 * the gate off, and the admin embed — is unchanged.
 */
export const DEFAULT_INTAKE_SHELL_HEIGHT = 'calc(100vh - 64px)';

export const IntakeShellHeightContext = createContext<string>(DEFAULT_INTAKE_SHELL_HEIGHT);
